import { Component, OnInit } from "@angular/core"
import { FeaturedService } from "../../services/featured.service"
import { LearningObject } from "../../models/learningObject.model"
import { EduComponent } from "../../utils/eduComponent"
import { CHNode } from "../../models/node.model"

@Component({
    selector: "app-featured",
    templateUrl: "./featured.component.html",
    styleUrls: ["./featured.component.less"],
})
export class FeaturedComponent extends EduComponent implements OnInit {
    public featuredResources: LearningObject[] = []
    placeholderImg = null
    public gtmPrefix = "homepage-featured"

    constructor(private featuredService: FeaturedService) {
        super()
        this.placeholderImg = require("../../../assets/placeholder-image.svg")
    }

    ngOnInit() {
        this.addSub(
            this.featuredService
                .getFeaturedResources()
                .subscribe((featuredResources: LearningObject[]) => {
                    this.featuredResources.push(...featuredResources)
                })
        )
    }

    getBrowseURL(resource) {
        if (!resource.subject || !resource.subject.slug) {
            return null
        }
        return CHNode.getBrowseURLForSlug(resource.subject.slug)
    }
}
